import styled from "styled-components";

const Identity = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1%;
  align-items: center;
  margin-left: 2%;
  @media screen and (max-width: 600px) {
    justify-content: center;
  }
`;

export default Identity;
